import { useEffect, useRef } from "react";

import { useStableRef } from "./useStableRef";

/**
 * Runs a callback exactly once on the final unmount of the component
 * - this is a last resort for cases where it is not possible to use the usual effect setup/cleanup
 */
export function useOnFinalUnmount(callback: () => void | Promise<void>) {
  const stableCallback = useStableRef(callback);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
      // Only runs cleanup if component didn't remount
      setTimeout(() => {
        if (!mountedRef.current) {
          // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally reading latest callback via stable ref
          void stableCallback.current();
        }
      }, 0);
    };
  }, [stableCallback]);
}
